// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1NJ6w","notes":"Notes_notes__3So9x"};